export var JSON_PREFIX = "__json=";
export var KEY_PREFIX = "formo";
//# sourceMappingURL=constant.js.map